export const getReferralType = (item = {}) => {
  if (item?.referral_type) return item.referral_type;
  return null;
};

export const getReferralDisplay = (item = {}) => {
  const referralType = getReferralType(item);

  switch (referralType) {
    case "in_out":
      return { type: referralType, tone: "both", label: "In/Out" };
    case "referred_in":
      return { type: referralType, tone: "in", label: "In" };
    case "referred_out":
      return { type: referralType, tone: "out", label: "Out" };
    default:
      return { type: null, tone: "none", label: "No Referral" };
  }
};
